import React, { useCallback } from 'react';
import { RootState } from 'app/rootReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addHouse, addRooms } from './houseSlice';
import { storeExtraFunc } from './extraSlice';
import { useHistory } from 'react-router-dom';
import logo from '../../app/logo.jpg';

export default function AddHouse(): JSX.Element {
    const house = useSelector(
        (state: RootState) => state.house
    )
    const dispatch = useDispatch()
    const [name, setName] = React.useState(house.houseName)
    const [r_amount, setRoomCount] = React.useState(house.roomAmount)
    const [f_amount, setFloorCount] = React.useState(house.floorAmount)
    const [el_install, set_el] = React.useState(house.el_install)
    const history = useHistory();
    const Callback = useCallback(() => history.push('hInfo'), [history]);
    let importFile: any

    // const dataURI = "data:text/plain;base64," + encodeBase64("Hello World!");
    // saveAs(dataURI, 'test.txt');
    // let blob = new Blob([JSON.stringify(json, null, 1)], {type: 'application/json;charset=utf-8'})
    // saveAs(blob, 'testJSON.json')

    function HandleSubmit(val: any){
        val.preventDefault()

        dispatch(addHouse(name, r_amount, f_amount, el_install))
        // history.push("/hInfo")
        Callback()
    }

    function placeFileContent(input: any){
        if (input === undefined) return alert('Ingen fil valgt, vennligst velg en fil før du lagrer den')
        const file = input.files[0]

        if (!file.name.split(".").includes("json")) return alert('Fil må være JSON')
        readFileContent(file).then((content: any) => {
            let importedInfo = JSON.parse(content);
            const extraValues = {
                varmepumpe: importedInfo.varmepumpe,
                z41: importedInfo.z41,
                weather: importedInfo.weather,
                ISE: importedInfo.ISE,
                porttlf: importedInfo.porttlf,
                logging: importedInfo.logging,
                mobile: importedInfo.mobile,
                timer: importedInfo.timer,
                rgbw: importedInfo.rgbw,
                waterdetection: importedInfo.waterdetection,
                solidstate: importedInfo.solidstate,
                constantlight: importedInfo.constantlight,
                sonos: importedInfo.sonos,
                network: importedInfo.network,
                port24: importedInfo.port24,
                accesspoints: importedInfo.accesspoints,
                effect: importedInfo.effect,
                access: importedInfo.access,
                outside: importedInfo.outside,
                macros: importedInfo.macros
            }
            dispatch(addHouse(importedInfo.houseName, importedInfo.roomAmount, importedInfo.floorAmount, importedInfo.el_install))
            dispatch(addRooms(importedInfo.rooms))
            dispatch(storeExtraFunc(extraValues))
            // history.push("/hInfo")
            Callback()  
        }).catch((error: any) => console.log(error))
    }

    function readFileContent(file: File){
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onload = (event: any) => resolve(event.target.result)
            reader.onerror = (error: any) => reject(error)
            reader.readAsText(file)
        })
    }

    return(
        <div>
            <img className="logo" src={logo} />
            <div className="mainDiv">
                <div className="infoDiv">
                    <h3>Ny Bolig</h3>
                    <form onSubmit={HandleSubmit}>
                        Navn: <input type="text" defaultValue={name} onChange={(event) => setName(event.currentTarget.value)} /> <br />

                        Antall rom: <input 
                            type="number" 
                            defaultValue={r_amount} 
                            onChange={(event) => setRoomCount(parseInt(event.currentTarget.value) === NaN 
                                ? 0 
                                : parseInt(event.currentTarget.value)
                            )} 
                        /> <br />
                        
                        Antall etasjer: <input 
                            type="number" 
                            defaultValue={f_amount} 
                            onChange={(event) => setFloorCount(parseInt(event.currentTarget.value) === NaN 
                                ? 0 
                                : parseInt(event.currentTarget.value)
                            )} 
                        /> <br />
                        <label htmlFor="el" className="chkBoxLabel">El-Installasjon? </label> <input id="el" defaultChecked={el_install} type="checkbox" onChange={(event) => set_el(event.currentTarget.checked)} /> <br />
                        <button className="btnContinue" type="submit">Neste</button>
                    </form>
                    <hr />
                </div>                
                <div className="infoDiv">
                    <h3>Importer eksisterende JSON fil</h3>
                    
                    <input type="file" name="import" onChange={(event) => importFile = event.target}/>
                    <button className="btnSave" onClick={() => placeFileContent(importFile)}>Lagre & Neste</button>
                </div>                
            </div>            
        </div>
        
    )
}